import React from 'react'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Avatar from '@material-ui/core/Avatar'
import { DOMESTIC_COLOURS } from './utils/colors'
import Check from '@mui/icons-material/CheckCircle'
import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { InsightNotEnabled } from './InsightNotEnabled'

interface ShowerCardProps
{
  showerBehaviour: any;
}

export const ShowerCard = ({ showerBehaviour }: ShowerCardProps) =>
{
  return(
    showerBehaviour.enabled ? <Card style={styles.cardContainer}>
      <CardHeader
        titleTypographyProps={{ variant:'h6' }}
        avatar={
          <Avatar style={{ ...styles.avatar, backgroundColor: showerBehaviour.status.value === "NORMAL" ? DOMESTIC_COLOURS.NORMAL : DOMESTIC_COLOURS.WARNING }}>
            {showerBehaviour.status.value === "NORMAL"  ? <Check fontSize="large" /> : <ErrorOutline fontSize="large"/> }
          </Avatar>
        }

        title="Shower Usage"
        subheader={showerBehaviour.status.msg}
      />
    </Card> : <InsightNotEnabled title="Shower Usage"/>
  )
}

const styles = {
  cardContainer: {
    padding: 12,
    flex: 1,
    borderRadius: 6,
    marginBottom: 12,
  },
  avatar: {
    width: 100,
    height: 100,
  },
  icon: {
    width: 100,
    height: 100,
  },
}